export const state = () => ({
    mobileMenu: {
        catalog: false,
        search: false,
    },
    dropdownMenu: {
        catalog: false,
        about: false,
    },
    basket: {
        count: 0,
    },
    version: {
        number: false,
        needRedirect: false,
    },
})

export const getters = {
    mobileMenuCatalog: state => state.mobileMenu.catalog,
    mobileMenuSearch: state => state.mobileMenu.search,
    getNeedRedirect(state) {
        return state.version.needRedirect
    },
}

export const mutations = {
    toggleMenuCatalog(state) {
        if(!state.mobileMenu.catalog){
            state.mobileMenu.search = false;
        }
        state.mobileMenu.catalog = !state.mobileMenu.catalog
    },
    closeMenuCatalog(state) {
        state.mobileMenu.catalog = false
    },
    toggleMenuSearch(state) {
        if(!state.mobileMenu.search){
            state.mobileMenu.catalog = false;
        }
        state.mobileMenu.search = !state.mobileMenu.search
    },
    closeMenuSearch(state) {
        state.mobileMenu.search = false
    },
    toggleDropdownMenuCatalog(state) {
        state.dropdownMenu.about = false
        state.dropdownMenu.catalog = !state.dropdownMenu.catalog
    },
    openDropdownMenuCatalog(state) {
        state.dropdownMenu.catalog = true
    },
    closeDropdownMenuCatalog(state) {
        state.dropdownMenu.catalog = false
    },
    toggleDropdownMenuAbout(state) {
        state.dropdownMenu.catalog = false
        state.dropdownMenu.about = !state.dropdownMenu.about
    },
    closeDropdownMenuAbout(state) {
        state.dropdownMenu.about = false
    },
    closeAllMenu(state){
        state.mobileMenu.catalog = false;
        state.mobileMenu.search = false;
        state.dropdownMenu.catalog = false;
        state.dropdownMenu.about = false;

    },
    setBasketCount(state, count){
        state.basket.count = count;
    },

    setVersion(state, version) {
        state.version.number = version;
    },

    checkVersion(state, version) {
        if(!state.version.number){
            state.version.number = version;
            return;
        }

        if(state.version.number !== version){
            state.version.needRedirect = true;
        }
    },
}

export const actions = {
    async nuxtServerInit({ commit }, { req }) {
        try {
            const {data: response} = await this.$axios.get('http://webserver/api/v1/version');
            commit('setVersion', response.version)
        } catch (e) {
            //console.log(e);
        }
    },
}
